let access = [];
access['publicacao'] = ['rh', 'admin', 'sadmin'];
access['publicacao/edit'] = ['rh', 'admin', 'sadmin'];

access['notificacao'] = ['rh', 'admin', 'sadmin'];
access['notificacao/edit'] = ['rh', 'admin', 'sadmin'];

access['comunicacaointerna'] = ['rh', 'admin', 'sadmin'];
access['comunicacaointerna/edit'] = ['rh', 'lider', 'admin', 'sadmin'];

access['bancodehoras'] = ['rh', 'admin', 'sadmin'];
access['bancodehoras/edit'] = ['rh', 'lider', 'admin', 'sadmin'];

access['user'] = ['rh', 'admin', 'sadmin'];

export default access;